import { useAuth0 } from "@auth0/auth0-react";
import { Button, Result } from "antd";
import { useDispatch } from "react-redux";
import { signout } from "../actions/auth_action";

const NoAccountPage = () => {
  const { logout } = useAuth0();
  const dispatch = useDispatch();

  const handleLogout = () => {
    logout();
    dispatch(signout());
  };
  return (
    <div className="no-account-wrapper">
      <Result
        status="404"
        title="No Account Found"
        subTitle="We couldn’t find an account associated with your session. You may need to log in again."
        extra={[
          <Button type="primary" key="login" onClick={handleLogout}>
            Logout
          </Button>,
        ]}
      />
    </div>
  );
};

export default NoAccountPage;
